module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/BenLeech/portfolio-website/portfolio-website/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0